import Module from '../module';
import gsap from 'gsap';
import scroll from '../../libs/scroll/scroll';
import newsletterServiceFactory, { PublicVarsInterface as NewsletterServiceSetupInterface } from './newsletter-service';

interface LayoutModuleConfigInterface {
	cssId: {
		headerLangCurrentId: string;
		headerMenuItemCls: string;
		headerMenuItemActiveCls: string;
		headerCls: string;
		headerSubmenuActiveCls: string;
		submenuCls: string;
		submenuActiveCls: string;
		submenuAreaCls: string;
		submenuAreaActiveCls: string;
		headerMenuMenuIconWrapperCls: string;
		headerMenuMobileInnerCls: string;
		headerMenuMobileInnerActiveCls: string;
		headerMenuMenuIconBarCls: string;
		layoutContainerWrapperCls: string;
		layoutContainerWrapperInactiveCls: string;
		headerMenuMobileItemHasSubmenuCls: string;
		headerMenuMobileItemActiveCls: string;
		headerMenuMobileSubmenuCls: string;

		headerStock?: {
			headerStockCls: string;
			headerStockIsLoadingCls: string;
			headerStockItemAimplsrPriceCls: string;
			headerStockItemAimplsrVolumeCls: string;
			headerStockItemTsxvplsrPriceCls: string;
			headerStockItemTsxvplsrVolumeCls: string;
			headerStockItemQtcqbpsrhfPriceCls: string;
			headerStockItemQtcqbpsrhfVolumeCls: string;
		}

		anim?: {
			footerMenuLinkCls: string;
			footerLogoCls: string;
			footerHeaderContactUsCls: string;
			footerPhoneItemCls: string;
			footerHeaderNewsletterCls: string;
			footerNewsletterInputCls: string;
			footerNewsletterSubmitCls: string;
			footerSocialItemCls: string;
			footerLegalMenuItemCls: string;
			footerLegalCopyTxtCls: string;
			footerLegalCopyPoweredCls: string;
		}
	};

	footerNewsletter?: NewsletterServiceSetupInterface

	rand?: string,
	apiNewsletterEndpoint?: string;
	apiNewsletterEndpointAction?: string;
	apiStockEndpoint?: string;
}

interface ServiceInterface {
	newsletterService?: ReturnType<typeof newsletterServiceFactory.create>;
}

declare global {
	interface Window {
		extLayoutModuleConfig: LayoutModuleConfigInterface;
	}
}

class Layout extends Module {

	publicVars: LayoutModuleConfigInterface;
	service: ServiceInterface = {};

	privateVars: {
		submenu: {
			initialActiveMenuItem: HTMLElement | null,
			initialActiveMobileMenuItem: HTMLElement | null,
			currentSubmenuTarget: string | null,
			opened: boolean,
			mobile: {
				iconAnimTimeline: ReturnType<typeof gsap.timeline> | null
			}
		},
	} = {
		submenu: {
			initialActiveMenuItem: null,
			initialActiveMobileMenuItem: null,
			currentSubmenuTarget: null,
			opened: false,
			mobile: {
				iconAnimTimeline: null
			}
		},
	};

	constructor() {
		super('Layout Module');
		this.publicVars = window['extLayoutModuleConfig'];
	}

	startup() {
		this.msg('startup');

		this.privateVars.submenu.initialActiveMenuItem =
			document.querySelector(this.publicVars.cssId.headerMenuItemActiveCls);

		this.privateVars.submenu.initialActiveMobileMenuItem = document.querySelector(this.publicVars.cssId.headerMenuMobileItemActiveCls);

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerMenuLinkCls + '1', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerMenuLinkCls + '2', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerMenuLinkCls + '3', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerMenuLinkCls + '4', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerMenuLinkCls + '5', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerMenuLinkCls + '6', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerLogoCls || '', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerHeaderContactUsCls || '', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerPhoneItemCls + '1', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerPhoneItemCls + '2', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerHeaderNewsletterCls || '', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerNewsletterInputCls || '', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerNewsletterSubmitCls || '', 'layout__footer', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerSocialItemCls + '1', 'layout__footer', { animCls: 'animate__fadeInRight', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerSocialItemCls + '2', 'layout__footer', { animCls: 'animate__fadeInRight', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerSocialItemCls + '3', 'layout__footer', { animCls: 'animate__fadeInRight', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerSocialItemCls + '4', 'layout__footer', { animCls: 'animate__fadeInRight', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerLegalMenuItemCls + '1', 'layout__footer', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerLegalMenuItemCls + '2', 'layout__footer', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerLegalMenuItemCls + '3', 'layout__footer', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerLegalCopyTxtCls || '', 'layout__footer', { animCls: 'animate__zoomIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.footerLegalCopyPoweredCls || '', 'layout__footer', { animCls: 'animate__fadeInRight', once: true});

		this.getAndShowStockData();

		if(this.publicVars.footerNewsletter) {
			this.service.newsletterService = newsletterServiceFactory.create();
			this.service.newsletterService.init(this.publicVars.footerNewsletter);
		} else {
			this.errorMsg('Footer newsletter needs setup');
		}
	}

	bind() {
		this.msg('bind');

		const headerMenuItemHtml = document.querySelectorAll(
			this.publicVars.cssId.headerMenuItemCls) as NodeListOf<HTMLElement>;

		const headerMenuMobileItemHtml = document.querySelectorAll(
			this.publicVars.cssId.headerMenuMobileItemHasSubmenuCls
		) as NodeListOf<HTMLElement>;

		const headerMenuIconHtml = document.querySelector(
			this.publicVars.cssId.headerMenuMenuIconWrapperCls) as HTMLElement;

		headerMenuItemHtml.forEach((item) => {
			item.addEventListener('click', () => {
				const targetSubmenu = item.dataset.submenu;

				this.handleMenuClick(item, targetSubmenu);
			});
		});

		headerMenuMobileItemHtml.forEach((item) => {
			item.addEventListener('click', () => {
				const targetSubmenu = item.dataset.submenu;

				this.handleMenuMobileClick(item, targetSubmenu);
			})
		});

		document.addEventListener('click', (event) => {
			const headerHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

			if (this.privateVars.submenu.opened && !headerHtml.contains(event.target as Node)) {
				this.handleMenuClick();
			}

			const headerMenuInnerHtml = document.querySelector(this.publicVars.cssId.headerMenuMobileInnerCls) as HTMLElement;

			if(headerMenuInnerHtml.classList.contains(this.publicVars.cssId.headerMenuMobileInnerActiveCls.substring(1))
				&& !headerHtml.contains(event.target as Node)
			) {
				this.handleMobileMenuOpen();
			}
		});

		headerMenuIconHtml.addEventListener('click', () => {
			this.handleMobileMenuOpen();
		});

		this.setupMenuIconBarsAnimTimeline();
	}

	async getAndShowStockData() {
		if(!this.publicVars?.apiStockEndpoint) {
			this.errorMsg('Please setup stock settings');
			return;
		}

		const headerStockHtml = document.querySelector(
			this.publicVars.cssId?.headerStock?.headerStockCls!) as HTMLElement;

		try {
			const result = await fetch(this.publicVars.apiStockEndpoint);

			if (!result.ok) {
				headerStockHtml.classList.remove(this.publicVars.cssId?.headerStock?.headerStockIsLoadingCls.substring(1) || '');
				return;
			}

			const data: {
				data: {
					plsrv: {
						price: string;
						volume: string;
					},
					plsrl: {
						price: string,
						volume: string
					},
					psrhf: {
						price: string,
						volume: string
					}
				}
			} = await result.json();

			const aimplsrPriceHtml = document.querySelector(this.publicVars.cssId?.headerStock?.headerStockItemAimplsrPriceCls!) as HTMLElement;
			const aimplsrVolumeHtml = document.querySelector(this.publicVars.cssId?.headerStock?.headerStockItemAimplsrVolumeCls!) as HTMLElement;

			aimplsrPriceHtml.innerHTML = '£' + parseFloat(data.data.plsrl.price);
			aimplsrVolumeHtml.innerHTML = '' + +data.data.plsrl.volume;

			const tsxvplsrPriceHtml = document.querySelector(this.publicVars.cssId?.headerStock?.headerStockItemTsxvplsrPriceCls!) as HTMLElement;
			const tsxvplsrVolumeHtml = document.querySelector(this.publicVars.cssId?.headerStock?.headerStockItemTsxvplsrVolumeCls!) as HTMLElement;

			tsxvplsrPriceHtml.innerHTML = '$' + parseFloat(data.data.plsrv.price);
			tsxvplsrVolumeHtml.innerHTML = '' + +data.data.plsrv.volume;

			const otcqbpsrhfPriceHtml = document.querySelector(this.publicVars.cssId?.headerStock?.headerStockItemQtcqbpsrhfPriceCls!) as HTMLElement;
			const otcqbpsrhfVolumeHtml = document.querySelector(this.publicVars.cssId?.headerStock?.headerStockItemQtcqbpsrhfVolumeCls!) as HTMLElement;

			otcqbpsrhfPriceHtml.innerHTML = '$' + parseFloat(data.data.psrhf.price);
			otcqbpsrhfVolumeHtml.innerHTML = '' + +data.data.psrhf.volume;

			headerStockHtml.classList.remove(this.publicVars.cssId?.headerStock?.headerStockIsLoadingCls.substring(1) || '');

		} catch(e) {
			headerStockHtml.classList.remove(this.publicVars.cssId?.headerStock?.headerStockIsLoadingCls.substring(1) || '');
			return;
		}


	}

	setupMenuIconBarsAnimTimeline() {
		this.privateVars.submenu.mobile.iconAnimTimeline = gsap.timeline({ paused: true });

		this.privateVars.submenu.mobile.iconAnimTimeline.to(this.publicVars.cssId.headerMenuMenuIconBarCls + '2', {
			left: '50%',
			width: '0',
			ease: 'power1.in',
			duration: 0.2
		}).add('end', 0.2)
			.to(this.publicVars.cssId.headerMenuMenuIconBarCls + '1', {
				rotate: '44deg',
				y: 11,
				ease: 'power1.in',
				duration: 0.2
			}, 'end')
			.to(this.publicVars.cssId.headerMenuMenuIconBarCls + '3', {
				rotate: '-44deg',
				y: -11,
				ease: 'power1.in',
				duration: 0.2
			}, 'end')
	}

	handleMobileMenuOpen() {

		const headerMenuInnerHtml = document.querySelector(this.publicVars.cssId.headerMenuMobileInnerCls) as HTMLElement;
		const layoutContainerWrapperHtml = document.querySelector(this.publicVars.cssId.layoutContainerWrapperCls) as HTMLElement;

		if (headerMenuInnerHtml.classList.contains(this.publicVars.cssId.headerMenuMobileInnerActiveCls.substring(1))) {
			layoutContainerWrapperHtml.classList.remove(this.publicVars.cssId.layoutContainerWrapperInactiveCls.substring(1));

			const rightPos = window.innerWidth <= 767 ? '-100%' : '-50%';

			gsap.to(headerMenuInnerHtml, {
				right: rightPos,
				ease: 'power2.out',
				duration: 0.5,
				onComplete: () => {
					headerMenuInnerHtml.classList.remove(this.publicVars.cssId.headerMenuMobileInnerActiveCls.substring(1));
					headerMenuInnerHtml.removeAttribute('style');
				}
			});

			this.privateVars.submenu.mobile.iconAnimTimeline?.reverse();
		} else {
			layoutContainerWrapperHtml.classList.add(this.publicVars.cssId.layoutContainerWrapperInactiveCls.substring(1));

			gsap.to(headerMenuInnerHtml, {
				right: 0,
				ease: 'power2.inOut',
				duration: 0.5,
				onComplete: () => {
					headerMenuInnerHtml.classList.add(this.publicVars.cssId.headerMenuMobileInnerActiveCls.substring(1));
				}
			});

			this.privateVars.submenu.mobile.iconAnimTimeline?.play();
		}
	}

	handleMenuClick(item?: HTMLElement, targetSubmenu?: string) {

		const headerHtml = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;
		const submenuHtml = document.querySelector(this.publicVars.cssId.submenuCls) as HTMLElement;

		const headerMenuItemHtml = document.querySelectorAll(
			this.publicVars.cssId.headerMenuItemCls) as NodeListOf<HTMLElement>;

		headerMenuItemHtml.forEach((item) => {
			item.classList.remove(this.publicVars.cssId.headerMenuItemActiveCls.substring(1));
		});

		if (!targetSubmenu || !item || this.privateVars.submenu.currentSubmenuTarget === targetSubmenu) {
			this.privateVars.submenu.initialActiveMenuItem?.classList.add(
				this.publicVars.cssId.headerMenuItemActiveCls.substring(1));

			const submenuAreaHtml = document.querySelector(
				`${this.publicVars.cssId.submenuAreaCls}-${this.privateVars.submenu.currentSubmenuTarget}`) as HTMLElement;

			headerHtml.classList.remove(this.publicVars.cssId.headerSubmenuActiveCls.substring(1));

			headerHtml.addEventListener('transitionend', () => {
				submenuHtml.classList.remove(this.publicVars.cssId.submenuActiveCls.substring(1));
				submenuHtml.removeAttribute('style');
				submenuAreaHtml.classList.remove(this.publicVars.cssId.submenuAreaActiveCls.substring(1));
				submenuAreaHtml.removeAttribute('style');

				this.privateVars.submenu.currentSubmenuTarget = null;
				this.privateVars.submenu.opened = false;

			}, { once: true });
		} else if (this.privateVars.submenu.currentSubmenuTarget && this.privateVars.submenu.currentSubmenuTarget !==
			targetSubmenu) {
			item.classList.add(this.publicVars.cssId.headerMenuItemActiveCls.substring(1));
			const submenuCurrentAreaHtml = document.querySelector(
				`${this.publicVars.cssId.submenuAreaCls}-${this.privateVars.submenu.currentSubmenuTarget}`) as HTMLElement;
			const submenuAreaHtml = document.querySelector(
				`${this.publicVars.cssId.submenuAreaCls}-${targetSubmenu}`) as HTMLElement;
			submenuCurrentAreaHtml.classList.remove(this.publicVars.cssId.submenuAreaActiveCls.substring(1));

			submenuAreaHtml.style.display = 'flex';

			requestAnimationFrame(() => {
				submenuAreaHtml.classList.add(this.publicVars.cssId.submenuAreaActiveCls.substring(1));
				submenuAreaHtml.removeAttribute('style');
				this.privateVars.submenu.currentSubmenuTarget = targetSubmenu;
				this.privateVars.submenu.opened = true;
			});

		} else {
			const submenuAreaHtml = document.querySelector(
				`${this.publicVars.cssId.submenuAreaCls}-${targetSubmenu}`) as HTMLElement;

			item.classList.add(this.publicVars.cssId.headerMenuItemActiveCls.substring(1));
			//submenuHtml.style.display = 'block';
			submenuAreaHtml.style.display = 'flex';

			window.requestAnimationFrame(() => {
					submenuHtml.classList.add(this.publicVars.cssId.submenuActiveCls.substring(1));

				window.requestAnimationFrame(() => {
					submenuAreaHtml.classList.add(this.publicVars.cssId.submenuAreaActiveCls.substring(1));
					submenuAreaHtml.removeAttribute('style');
					headerHtml.classList.add(this.publicVars.cssId.headerSubmenuActiveCls.substring(1));
					this.privateVars.submenu.currentSubmenuTarget = targetSubmenu;
					this.privateVars.submenu.opened = true;
				});
			});

		}
	}

	handleMenuMobileClick(item?: HTMLElement, targetSubmenu?: string) {

		if(!item) {
			return;
		}

		const targetSubmenuHtml = document.querySelector(this.publicVars.cssId.headerMenuMobileSubmenuCls + '-' + targetSubmenu) as HTMLElement;

		const initialActiveMenuTarget = this.privateVars.submenu.initialActiveMobileMenuItem?.dataset.submenu;

		if(item.classList.contains(this.publicVars.cssId.headerMenuMobileItemActiveCls.substring(1))) {
			item.classList.remove(this.publicVars.cssId.headerMenuMobileItemActiveCls.substring(1));
			const targetHeight = targetSubmenuHtml.offsetHeight;
			targetSubmenuHtml.style.overflow = 'hidden';

			if(initialActiveMenuTarget !== targetSubmenu) {
				// this.privateVars.submenu.initialActiveMobileMenuItem?.classList.add(
				// 	this.publicVars.cssId.headerMenuMobileItemActiveCls.substring(1));

				this.privateVars.submenu.initialActiveMobileMenuItem?.click();
			}

			gsap.fromTo(targetSubmenuHtml, {
				display: 'block',
				opacity: 1,
				height: targetHeight
			}, {
				opacity: 0,
				height: '0',
				duration: 0.5,
				ease: 'power1.out',
				onComplete: () => {
					targetSubmenuHtml.removeAttribute('style');
					targetSubmenuHtml.style.display = 'none';
				}
			})

		} else {
			const currentActive = document.querySelector(
				this.publicVars.cssId.headerMenuMobileItemActiveCls) as HTMLElement;
			if (currentActive) {
				currentActive.classList.remove(this.publicVars.cssId.headerMenuMobileItemActiveCls.substring(1));
				const previousTarget = currentActive.dataset.submenu;

				const targetSubmenuHtml = document.querySelector(
					this.publicVars.cssId.headerMenuMobileSubmenuCls + '-' + previousTarget) as HTMLElement;

				targetSubmenuHtml.style.display = 'none';
			}

			item.classList.add(this.publicVars.cssId.headerMenuMobileItemActiveCls.substring(1));

			targetSubmenuHtml.style.display = 'block';
			const targetHeight = targetSubmenuHtml.offsetHeight;

			targetSubmenuHtml.style.overflow = 'hidden';

			gsap.fromTo(targetSubmenuHtml, {
				display: 'block',
				opacity: 0,
				height: 0,
			}, {
				opacity: 1,
				height: targetHeight,
				duration: 0.5,
				ease: 'power1.out',
				onComplete: () => {
					targetSubmenuHtml.removeAttribute('style');
					targetSubmenuHtml.style.display = 'block';
				}
			})
		}

	}
}

const layout = new Layout();
layout.init();